module.exports = __webpack_public_path__ + "img/1.c2be85d7.jpg";